import React from 'react';
import { Row, Col, Card, Badge, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic, faFileAlt, faCalendarAlt, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const PlaylistStatusSection = ({ 
  selectedReport, 
  sectionVisibility, 
  handleShopListModal 
}) => {
  if (!sectionVisibility.playlistStatus) return null;

  return (
    <>
      {/* IMS Status - Enhanced Visibility */}
      <Row className="mb-4">
        <Col md={12}>
          <Card className="shadow-lg report-card border-0" style={{borderLeft: '6px solid #8e44ad'}}>
            <Card.Header style={{
              background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)', 
              color: 'white',
              border: 'none'
            }}>
              <Row className="align-items-center">
                <Col>
                  <h5 className="mb-0 text-white">
                    <FontAwesomeIcon icon={faMusic} size="lg" className="me-3 text-white" />
                    System zarządzania muzyką (IMS)
                  </h5>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-4">
              <Row>
                {/* Playlisty */}
                <Col md={4} className="text-center mb-3">
                  <div className="p-4 border rounded-3 bg-light h-100" style={{borderLeft: '4px solid #e74c3c'}}>
                    <FontAwesomeIcon icon={faMusic} size="3x" className="text-danger mb-3" />
                    <h2 className="display-4 fw-bold text-danger mb-2">{selectedReport.data?.imsInfo?.totalPlaylists || 0}</h2>
                    <h6 className="text-muted mb-1">Aktywne playlisty</h6>
                    <p className="small text-muted mb-0">Gotowe do odtwarzania w drogeriach</p>
                  </div>
                </Col>

                {/* Pliki Muzyczne */}
                <Col md={4} className="text-center mb-3">
                  <div className="p-4 border rounded-3 bg-light h-100" style={{borderLeft: '4px solid #3498db'}}>
                    <FontAwesomeIcon icon={faFileAlt} size="3x" className="text-primary mb-3" />
                    <h2 className="display-4 fw-bold text-primary mb-2">{selectedReport.data?.imsInfo?.filesCount || 0}</h2>
                    <h6 className="text-muted mb-1">Pliki muzyczne</h6>
                    <p className="small text-muted mb-0">Łączna liczba utworów w bibliotece</p>
                  </div>
                </Col>

                {/* Status Kampanii */}
                <Col md={4} className="text-center mb-3">
                  <div className="p-4 border rounded-3 bg-light h-100" style={{borderLeft: '4px solid #f39c12'}}>
                    <FontAwesomeIcon icon={faCalendarAlt} size="3x" className="text-warning mb-3" />
                    {selectedReport.data?.imsInfo?.end ? (
                      <>
                        <h4 className="fw-bold text-warning mb-2">
                          {new Date(selectedReport.data.imsInfo.end).toLocaleDateString("pl-PL", {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </h4>
                        <h6 className="text-muted mb-1">Koniec kampanii</h6>
                        <p className="small text-muted mb-0">
                          {(() => {
                            const endDate = new Date(selectedReport.data.imsInfo.end);
                            const today = new Date();
                            const diffTime = endDate - today;
                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                            
                            if (diffDays > 0) {
                              return `Pozostało ${diffDays} dni`;
                            } else if (diffDays === 0) {
                              return "Kończy się dzisiaj";
                            } else {
                              return `Zakończona ${Math.abs(diffDays)} dni temu`;
                            }
                          })()}
                        </p>
                      </>
                    ) : (
                      <>
                        <h4 className="fw-bold text-muted mb-2">Brak danych</h4>
                        <h6 className="text-muted mb-1">Status Kampanii</h6>
                        <p className="small text-muted mb-0">Nie określono daty końca</p>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Playlist Player MA Status Section */}
      {selectedReport.data?.devicePlayingInfo && (
        <Row className="mb-4">
          <Col md={12}>
            <Card className="shadow-lg report-card border-0" style={{borderLeft: '6px solid #e67e22'}}>
              <Card.Header style={{
                background: 'linear-gradient(135deg, #e67e22 0%, #f39c12 100%)', 
                color: 'white',
                border: 'none'
              }}>
                <Row className="align-items-center">
                  <Col>
                    <h5 className="mb-0 text-white">
                      <FontAwesomeIcon icon={faMusic} size="lg" className="me-3 text-white" />
                      Status odtwarzania playlist (MA)
                    </h5>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body className="p-4">
                <Row>
                  {/* Combined CMS & IMS Configuration */}
                  <Col md={12} lg={4} className="mb-3">
                    <div className="p-4 border rounded-3 bg-light h-100" style={{borderLeft: '4px solid #e67e22'}}>
                      <h6 className="text-muted mb-3">Playlista skonfigurowana w urządzeniu</h6>
                      
                      {/* CMS Row */}
                      <div className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded" style={{backgroundColor: '#f8f9fa'}}>
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon icon={faFileAlt} className="text-primary me-2" />
                          <span className="fw-bold text-primary">CMS</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="primary" className="fs-6">
                            {selectedReport.data.devicePlayingInfo.playlistCMSEnabled?.length || 0}
                          </Badge>
                          {selectedReport.data.devicePlayingInfo.playlistCMSEnabled?.length > 0 && (
                            <Badge 
                              bg="outline-primary" 
                              className="clickable-badge"
                              style={{cursor: 'pointer', color: '#0d6efd', borderColor: '#0d6efd'}}
                              onClick={() => handleShopListModal(
                                'Sklepy skonfigurowane do CMS', 
                                selectedReport.data.devicePlayingInfo.playlistCMSEnabled,
                                'CMS - skonfigurowane'
                              )}
                            >
                              Lista drogerii
                            </Badge>
                          )}
                        </div>
                      </div>

                      {/* IMS Row */}
                      <div className="d-flex justify-content-between align-items-center p-2 border rounded" style={{backgroundColor: '#f8f9fa'}}>
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon icon={faMusic} className="me-2" style={{color: '#9b59b6'}} />
                          <span className="fw-bold" style={{color: '#9b59b6'}}>IMS</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <Badge className="fs-6" style={{backgroundColor: '#9b59b6'}}>
                            {selectedReport.data.devicePlayingInfo.playlistIMSEnabled?.length || 0} 
                          </Badge>
                          {selectedReport.data.devicePlayingInfo.playlistIMSEnabled?.length > 0 && (
                            <Badge 
                              bg="outline-secondary" 
                              className="clickable-badge"
                              style={{cursor: 'pointer', color: '#9b59b6', borderColor: '#9b59b6'}}
                              onClick={() => handleShopListModal(
                                'Drogerie skonfigurowane do IMS', 
                                selectedReport.data.devicePlayingInfo.playlistIMSEnabled,
                                'IMS - skonfigurowane'
                              )}
                            >
                              Lista Drogerii
                            </Badge>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>

                  {/* Total Playing */}
                  <Col md={6} lg={4} className="mb-3">
                    <div className="p-4 border rounded-3 bg-light h-100" style={{borderLeft: '4px solid #27ae60'}}>
                      <FontAwesomeIcon icon={faCheckCircle} size="2x" className="text-success mb-3" />
                      <h3 className="fw-bold text-success mb-2">
                        {selectedReport.data.devicePlayingInfo.playlistPlaying?.length || 0}
                      </h3>
                      <h6 className="text-muted mb-1">Aktywnie odtwarzające</h6>
                      <p className="small text-muted mb-0">Urządzenia w trakcie odtwarzania</p>
                      {selectedReport.data.devicePlayingInfo.playlistPlaying?.length > 0 && (
                        <Badge 
                          bg="success" 
                          className="mt-2 clickable-badge"
                          style={{cursor: 'pointer'}}
                          onClick={() => handleShopListModal(
                            'Urządzenia aktywnie odtwarzające', 
                            selectedReport.data.devicePlayingInfo.playlistPlaying,
                            'Aktywnie odtwarzające'
                          )}
                        >
                          Zobacz listę drogerii
                        </Badge>
                      )}
                    </div>
                  </Col>

                  {/* Total Not Playing */}
                  <Col md={6} lg={4} className="mb-3">
                    <div className="p-4 border rounded-3 bg-light h-100" style={{borderLeft: '4px solid #dc3545'}}>
                      <FontAwesomeIcon icon={faTimesCircle} size="2x" className="text-danger mb-3" />
                      <h3 className="fw-bold text-danger mb-2">
                        {selectedReport.data.devicePlayingInfo.playlistNotPlaying?.length || 0}
                      </h3>
                      <h6 className="text-muted mb-1">Urządzenia nieodtwarzające</h6>
                      {selectedReport.data.devicePlayingInfo.playlistNotPlaying?.length > 0 && (
                        <Badge 
                          bg="danger" 
                          className="mt-2 clickable-badge"
                          style={{cursor: 'pointer'}}
                          onClick={() => handleShopListModal(
                            'Urządzenia aktualnie nie odtwarzające', 
                            selectedReport.data.devicePlayingInfo.playlistNotPlaying,
                            'Aktualnie nie odtwarzające'
                          )}
                        >
                          Zobacz listę drogerii
                        </Badge>
                      )}
                    </div>
                  </Col>
                </Row>

                {/* Detailed Playing Status */}
                <Row className="mt-3">
                  <Col md={6}>
                    <Card className="h-100 border-primary">
                      <Card.Header className="bg-primary text-white">
                        <h6 className="mb-0">
                          <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                          CMS - odtwarzanie
                        </h6>
                      </Card.Header>
                      <Card.Body>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="fw-bold">Aktualnie odtwarzające:</span>
                          <Badge bg="primary" className="fs-6">
                            {selectedReport.data.devicePlayingInfo.playlistCMSPlaying?.length || 0}
                          </Badge>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="fw-bold text-danger">Aktualnie nieodtwarzające:</span>
                          <Badge bg="danger" className="fs-6">
                            {selectedReport.data.devicePlayingInfo.playlistCMSNotPlaying?.length || 0}
                          </Badge>
                        </div>
                        
                        <div className="d-grid gap-2">
                          {selectedReport.data.devicePlayingInfo.playlistCMSPlaying?.length > 0 && (
                            <Button 
                              variant="outline-primary" 
                              size="sm"
                              onClick={() => handleShopListModal(
                                'Urządzenia odtwarzające z CMS', 
                                selectedReport.data.devicePlayingInfo.playlistCMSPlaying,
                                'CMS - aktywne odtwarzanie'
                              )}
                            >
                              <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                              Zobacz odtwarzające CMS
                            </Button>
                          )}
                          {selectedReport.data.devicePlayingInfo.playlistCMSNotPlaying?.length > 0 && (
                            <Button 
                              variant="outline-danger" 
                              size="sm"
                              onClick={() => handleShopListModal(
                                'Urządzenia CMS nieodtwarzające', 
                                selectedReport.data.devicePlayingInfo.playlistCMSNotPlaying,
                                'CMS - nieodtwarzające'
                              )}
                            >
                              <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                              Zobacz nieodtwarzające CMS
                            </Button>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="h-100" style={{borderColor: '#9b59b6'}}>
                      <Card.Header style={{backgroundColor: '#9b59b6', color: 'white'}}>
                        <h6 className="mb-0">
                          <FontAwesomeIcon icon={faMusic} className="me-2" />
                          IMS - odtwarzanie
                        </h6>
                      </Card.Header>
                      <Card.Body>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="fw-bold">Aktualnie odtwarzające:</span>
                          <Badge className="fs-6" style={{backgroundColor: '#9b59b6'}}>
                            {selectedReport.data.devicePlayingInfo.playlistIMSPlaying?.length || 0}
                          </Badge>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="fw-bold text-danger">Aktualnie nieodtwarzające:</span>
                          <Badge bg="danger" className="fs-6">
                            {selectedReport.data.devicePlayingInfo.playlistIMSNotPlaying?.length || 0}
                          </Badge>
                        </div>
                        
                        <div className="d-grid gap-2">
                          {selectedReport.data.devicePlayingInfo.playlistIMSPlaying?.length > 0 && (
                            <Button 
                              variant="outline-secondary" 
                              size="sm"
                              style={{borderColor: '#9b59b6', color: '#9b59b6'}}
                              onClick={() => handleShopListModal(
                                'Urządzenia odtwarzające z IMS', 
                                selectedReport.data.devicePlayingInfo.playlistIMSPlaying,
                                'IMS - aktywne odtwarzanie'
                              )}
                            >
                              <FontAwesomeIcon icon={faMusic} className="me-2" />
                              Zobacz odtwarzające IMS
                            </Button>
                          )}
                          {selectedReport.data.devicePlayingInfo.playlistIMSNotPlaying?.length > 0 && (
                            <Button 
                              variant="outline-danger" 
                              size="sm"
                              onClick={() => handleShopListModal(
                                'Urządzenia IMS nieodtwarzające', 
                                selectedReport.data.devicePlayingInfo.playlistIMSNotPlaying,
                                'IMS - nieodtwarzające'
                              )}
                            >
                              <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                              Zobacz nieodtwarzające IMS
                            </Button>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default PlaylistStatusSection;